module.exports = __webpack_public_path__ + "static/media/estee-lauder-2-logo-png-transparent.b13a5c87.png";